import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { setTutorialStep } from 'shared/state/slices/tutorial/tutorial';
import LegacyHome from './LegacyHome';
import DynamicHome from './DynamicHome';
import { checkDynamicGameRooms } from 'shared/state/query/games/utils';

const mapStateToProps = state => {
  return {
    isTutorialActive: state.tutorial.activeTutorial,
    tutorialStep: state.tutorial.tutorialStep,
  };
};

const mapDispatchToProps = { setTutorialStep };

const Home = props => {
  const isDynamicRoom = useMemo(() => checkDynamicGameRooms(), []);
  return isDynamicRoom ? <DynamicHome {...props} /> : <LegacyHome {...props} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

